import { Box, Button, Flex, Text } from '@workwhile/ui'
import styled from 'styled-components'
import { XIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useLayoutContext } from '../useLayoutContext'
import { TOP_BANNER_HEIGHT } from './constants'
import { SHELL_SM_BREAKPOINT } from '../PageContainer'
import { track } from 'lib/amplitude'

// Matches the page panel's rounded top corners
const TopBannerContainer = styled(Box)`
  display: none;
  position: relative;
  height: ${TOP_BANNER_HEIGHT}px;
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
  background-color: ${({ theme }) => theme.colors.primary300};
  color: ${({ theme }) => theme.colors.white};
  align-items: center;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.space[6]};

  @media (min-width: ${SHELL_SM_BREAKPOINT}) {
    display: flex;
  }
`

const ActionLink = styled(Button)`
  text-decoration: none;
  border-radius: 38px;
  height: 28px;
  padding: 0 1.2rem;
  flex-shrink: 0;
`

const DismissButton = styled(Button)`
  position: absolute;
  right: ${({ theme }) => theme.space[3]};
  top: 1rem;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 1px 2px;
`

export const TopBanner = () => {
  const navigate = useNavigate()
  const { showTopBanner, dismissTopBanner } = useLayoutContext()

  const onViewDashboard = () => {
    track('button_click, top_banner_view_dashboard_pulse')
    navigate('/pulse')
  }

  if (!showTopBanner) {
    return null
  }

  return (
    <TopBannerContainer>
      <Flex flexDirection="row" alignItems="center" gap={3}>
        <Text>
          <strong>New: Pulse is live —</strong> Monitor your entire flexible
          workforce and optimize labor costs in real-time.
        </Text>
        <ActionLink variant="primary" kind="small" onClick={onViewDashboard}>
          View Dashboard
        </ActionLink>
      </Flex>
      <DismissButton variant="primary" kind="small" onClick={dismissTopBanner}>
        <XIcon size={20} />
      </DismissButton>
    </TopBannerContainer>
  )
}
